import styled from "styled-components/macro";

export const HeroImage = styled.img`
  position: absolute;
  inset: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;
